// descriminator for narrative vs matched
export var ModeOfPlay;
(function (ModeOfPlay) {
    // not labeled
    ModeOfPlay[ModeOfPlay["Unknown"] = 0] = "Unknown";
    // this object could be for anything
    ModeOfPlay[ModeOfPlay["Any"] = 1] = "Any";
    // this object is specifically for matched play
    ModeOfPlay[ModeOfPlay["MatchedPlay"] = 2] = "MatchedPlay";
    // this object is specifically for narrative
    ModeOfPlay[ModeOfPlay["PathToGlory"] = 3] = "PathToGlory";
    // hobby collection tracker
    ModeOfPlay[ModeOfPlay["Collection"] = 4] = "Collection";
})(ModeOfPlay || (ModeOfPlay = {}));
// all the path battlepacks
export var PtgBattlePack;
(function (PtgBattlePack) {
    PtgBattlePack["Ascension"] = "Ascension";
    PtgBattlePack["RavagedCoast"] = "Ravaged Coast";
    PtgBattlePack["BlightedWilds"] = "Blighted Wilds";
    PtgBattlePack["Unknown"] = "Unknown";
})(PtgBattlePack || (PtgBattlePack = {}));
// All the matched play battlepacks
export var MpBattlePack;
(function (MpBattlePack) {
    MpBattlePack["Core"] = "Core";
    MpBattlePack["Ghb2024"] = "General's Handbook 2024-25";
    MpBattlePack["Ghb2025"] = "General's Handbook 2025-26";
    MpBattlePack["Ghb2026"] = "General's Handbook 2026-27";
    MpBattlePack["Unknown"] = "Unknown";
})(MpBattlePack || (MpBattlePack = {}));
// The current General's Handbook season. Matched-play lists on an older GHB can be
// updated to this one (see updateListToLatestGhb). Bump this when a new GHB ships.
export const LATEST_GHB = MpBattlePack.Ghb2026;
// True for a matched-play list that is already on the latest GHB (or whose pack is
// not an older GHB we offer to update from).
export function isLatestGhb(battlePack) {
    return battlePack === LATEST_GHB;
}
export var CollectionBattlePack;
(function (CollectionBattlePack) {
    CollectionBattlePack["Collection"] = "Collection";
    CollectionBattlePack["Unknown"] = "Unknown";
})(CollectionBattlePack || (CollectionBattlePack = {}));
export const allBattlePacks = [
    ...Object.values(MpBattlePack).filter((bp) => bp !== MpBattlePack.Unknown),
    ...Object.values(PtgBattlePack).filter((bp) => bp !== PtgBattlePack.Unknown),
    ...Object.values(CollectionBattlePack).filter((bp) => bp !== CollectionBattlePack.Unknown),
];
export function isPtgBattlePack(battlePack) {
    return Object.values(PtgBattlePack).includes(battlePack);
}
export function isMpBattlePack(battlePack) {
    return Object.values(MpBattlePack).includes(battlePack);
}
export function isCollectionBattlePack(battlePack) {
    return Object.values(CollectionBattlePack).includes(battlePack);
}
export function isCustomBattlePack(battlePack) {
    return (!isMpBattlePack(battlePack) &&
        !isPtgBattlePack(battlePack) &&
        !isCollectionBattlePack(battlePack));
}
